import * as apiCalculate from 'api/recipe/PostRecipeCalculateV1';
import { IngredientType } from 'enums/ingredientType';
import * as Ingredient from 'types/Recipe/Detail/ErpNew/Ingredient';
import * as IngredientList from 'types/Recipe/Detail/ErpNew/IngredientList';
import * as Segment from 'types/Recipe/Segment';
import * as SegmentIngredient from 'types/Recipe/SegmentIngredient';

import { IncorporationShare } from './Recipe';

export type Type = Segment.Segment[];

export function create(): Type {
	return [];
}

export function mergeWithProductMappings(input: Type, mappings: IngredientList.Type): Type {
	for (const segment of input) {
		for (const ingredient of segment.ingredients) {
			if (!ingredient.ingredientId) continue;
			const productId = IngredientList.getSelectedProductId(
				mappings,
				segment.index,
				ingredient.ingredientId
			);
			ingredient.productId = productId;
		}
	}
	return input;
}

export function mapToErpMappingList(input: Type): IngredientList.Type {
	const output: IngredientList.Type = [];
	for (const segment of input) {
		for (const i of segment.ingredients) {
			if (!i.ingredientId) continue;
			if (i.type === IngredientType.Accessory) continue;
			output.push({
				...Ingredient.create(),
				ingredientId: i.ingredientId,
				segmentIndex: segment.index,
			});
		}
	}
	return output;
}

function mapIngredientsToApi(
	obj: Type,
	input: {
		incorporationShares: (IncorporationShare & { index: number })[];
		ingredients: IngredientList.Type;
	}
): apiCalculate.Ingredients[] {
	const output = [];
	for (const segment of obj) {
		for (const ingredient of segment.ingredients) {
			if (ingredient.type !== IngredientType.Ingredient) continue;
			if (!ingredient.ingredientId) continue;
			const item = SegmentIngredient.mapIngredientToAPIIngredient(
				{
					index: segment.index,
					segmentIngredient: ingredient,
					ingredients: input.ingredients,
				},
				input.incorporationShares
			);
			output.push(item);
		}
	}
	return output;
}

function mapAccessoriesToApi(obj: Type): apiCalculate.Accessories[] {
	const output = [];
	for (const segment of obj) {
		for (const ingredient of segment.ingredients) {
			if (ingredient.type !== IngredientType.Accessory) continue;
			if (!ingredient.ingredientId) continue;
			const item = SegmentIngredient.mapAccessoryToAPIAccessory({
				index: segment.index,
				segmentIngredient: ingredient,
			});
			output.push(item);
		}
	}
	return output;
}

export function mapToApi(input: {
	segments: Type;
	incorporationShares: (IncorporationShare & { index: number })[];
	currencyCode: string | null;
	ingredients: IngredientList.Type;
}): apiCalculate.Request {
	return {
		ingredients: mapIngredientsToApi(input.segments, input),
		accessories: mapAccessoriesToApi(input.segments),
		currencyCode: input.currencyCode,
	};
}

export function getAllIngredientIds(obj: Type): string[] {
	return obj.flatMap((e) => {
		return e.ingredients.map((e) => e.ingredientId ?? '');
	});
}
